import { humanize, slugify } from 'underscore.string';
import WithErrorHandling from 'src/components/hoc/withErrorHandling';
import TagPage from 'src/modules/tag/tagPage';
import { TagPageProps } from 'src/modules/tag/types';
import { validateTag } from 'src/api/tag';
import { fetchTagPosts, fetchTagCommunities, fetchNHSTagContent } from 'src/modules/tag/actions';
import { PageContext } from 'src/constants/types';

const Page = ({ longName, tagName, type }: TagPageProps) => (
  <TagPage longName={longName} tagName={tagName} type={type} />
);

Page.getInitialProps = async ({ query: { community, page, slug, sort, type }, res, store: { dispatch } }: PageContext) => {
  const communityFilter = community || 'all';
  const pageNumber = Number(page) || 1;
  const formattedSlug = humanize(slug).toLowerCase();
  const sortedBy = sort || 'most-relevant';
  const tagName = slugify(slug);

  const response = await validateTag(tagName);
  if (!response.success && response.redirect) {
    res.writeHead(301, { Location: response.location });
    res.end();
    return {};
  }
  if (!response.success) {
    res.statusCode = response.status;
    return { status: response.status };
  }
  if (response.success && response.tagType) {
    await dispatch(fetchNHSTagContent(tagName, response.tagType));
  }

  if (type === 'communities') {
    await dispatch(fetchTagCommunities(formattedSlug, pageNumber));
  } else {
    await dispatch(fetchTagPosts(formattedSlug, pageNumber, communityFilter, sortedBy));
  }

  return {
    longName: response.longName || humanize(slug),
    tagName,
    type: type || 'posts',
  };
};

export default WithErrorHandling(Page);
